import { initialOptionValues } from '../constants';
import {
  calculateSum,
  handleDownAndMonthlyPmt,
  updateEachItem,
  processDownPayment,
  calculateGiftCard,
} from '.';
import { handlePrimaryLender, handleSecondaryLender } from './mmf';

export const updateOptionProps = (option, active) => {
  if (!option) return; // Sometimes option is being passed as undefined for some reason
  if (option.items.length === 0) return initialOptionValues;

  const cohort = active.state.cohort; // cohort number 1, 2, 3, 4

  // option.financePlan = getFinancePlan(active, option); // Deprecated
  option.financePlan = active.financePlan;

  // DISCOUNTS['BNDLE'] = active.preSale ? 0.64 : 0.6

  // -> PIF logic goes here if needed

  updateEachItem(active, option, cohort);

  // Note: for option.fee Do NOT do finalTotalCost * fee -> it is not correct
  // Keep this line after updateEachItem() to get the correct fee value
  option.fee = calculateSum(option.items.map((item) => item.fee));

  option.totalOriginalCost = calculateSum(
    option.items.map((item) => item.prices[`cohort_${cohort}`]),
  );
  const accurateFinalTotalCost =
    calculateSum(option.items.map((item) => item.finalCost)) + option.fee;
  // option.finalTotalCost = Math.round(accurateFinalTotalCost - 0.5); // Subtracting 0.5 would make the .5 round down
  option.finalTotalCost = Math.round(accurateFinalTotalCost);

  // Total Financed is the final total cost minus Today's Payment
  option.totalFinanced = option.finalTotalCost - option.todaysPayment;
  // ------------- Down Payment Logic ------------------ //
  processDownPayment(active, option);

  // ----- Total Savings ----- //
  const totalSavings =
    option.totalOriginalCost - option.finalTotalCost + option.fee;

  option.totalSavings = // This is for UI display only
    active.state.id === 'connecticut'
      ? Math.ceil(totalSavings - 0.5) // For Connecticut, subtracting 0.5 and rounding up seems to give the expected result.
      : Math.floor(totalSavings); // For Colorado, When not rounding down, the Discount Savings is 1$ more sometimes.

  //   option.totalSavings = totalSavings;

  // ---- 🚨 Throwback & Non Standard Terms Logic Goes Here If Needed 🚨 ---- //

  // System Design: Each term duration has ONLY ONE variant in the lender's terms array
  const {
    rate: { min, max },
  } = active.lender.terms.find((t) => t.term === option.financePlan);
  const minRate = min / 100;
  const maxRate = max / 100;

  // ******************* Split Finance Logic *********************** //
  // This is useful when deleting areas from an Option Tile -> This will decrease the final total cost and the total financed
  // Also, if Split Finance check box is unchecked
  const { isEnabled, primaryLender, secondaryLender } = option.splitLoan;
  if (
    primaryLender.approvedAmount >= option.finalTotalCost ||
    !isEnabled ||
    !active.myMilanSecondary
  ) {
    primaryLender.approvedAmount =
      primaryLender.financedAmount =
      primaryLender.requiredDownPmt =
      secondaryLender.financedAmount =
      secondaryLender.requiredDownPmt =
        0;
    primaryLender.monthlyPayment = secondaryLender.monthlyPayment = [];
  }
  const isSplitLoanActive =
    isEnabled && option.items.length > 0 && primaryLender.approvedAmount > 0;
  if (isSplitLoanActive) {
    handlePrimaryLender(active, option, primaryLender, minRate, maxRate);
    handleSecondaryLender(
      active,
      option,
      primaryLender,
      secondaryLender,
      accurateFinalTotalCost,
    );

    // ---- $$$$ Overall Monthly Payment / Primary & Secondary combined $$$$ ---- //
    option.monthlyPayment =
      primaryLender.monthlyPayment.length === 2 // This means it's a range (has 2 elements)
        ? [
            primaryLender.monthlyPayment[0] + secondaryLender.monthlyPayment[0],
            primaryLender.monthlyPayment[1] + secondaryLender.monthlyPayment[0],
          ]
        : // OR, No range
          [primaryLender.monthlyPayment[0] + secondaryLender.monthlyPayment[0]];

    // This is very important. Otherwise, the nested object won't update
    option.splitLoan.primaryLender = { ...primaryLender };
    option.splitLoan.secondaryLender = { ...secondaryLender };

    // Update Total Financed
    option.totalFinanced =
      primaryLender.financedAmount + secondaryLender.financedAmount;
  } else {
    // Default --- ******************** NO Split Loan applied ********************** //
    handleDownAndMonthlyPmt(
      active,
      option,
      minRate,
      maxRate,
      accurateFinalTotalCost,
    );
  }

  option.additionalDownPmt = option.todaysPayment - option.requiredDownPmt;
  // ******* IMPORTANT ********* // KEEP THIS LOGIC AT THE END // To avoid overwriting the prop somewhere else.
  // $$ The logic below is only to make the sum of the items in the Manager's section match the displayed Your Cost
  // ------------------------------------- ------------------------------------- ------------------------------------- //
  const residue = option.finalTotalCost - accurateFinalTotalCost; // Could be a few cents more or less
  if (residue !== 0) option.items[0].finalCost += residue;

  // totalFinanced is the one used in calculation
  // displayedFinanced is the one displayed to avoid confusion for the user especially when down payment is required
  option.displayedFinanced = option.totalFinanced;

  // ---------------------------------- Special Case When Lender requires down payment ------------------------------- //
  // When Lender requires down payment (e.g. Covered Care SEC, HFDT, ClarityPayT)
  const { downPmtEnabled, additionalDownPmt, finalTotalCost } = option;
  if (active.lender.downpayment > 0) {
    // Do NOT display the financed amount when NO additional down payment is entered & NO split loan is applied
    option.displayedFinanced = 0;
    //  When additional down payment is entered, display the financed amount
    if (downPmtEnabled && additionalDownPmt > 0) {
      // * Case 1: Split Loan is applied
      if (isSplitLoanActive) {
        option.displayedFinanced =
          finalTotalCost - additionalDownPmt - secondaryLender.requiredDownPmt;
      } else {
        // * Case 2: Split Loan is NOT applied
        option.displayedFinanced = finalTotalCost - additionalDownPmt;
      }
    }
  }
  // ------------------------------------- ------------------------------------- ------------------------------------- //

  // E-Gift Card Logic // Don't include the fee
  option.giftCardAmount = calculateGiftCard(option.totalFinanced - option.fee);
  // ------------------------------------- ------------------------------------- ------------------------------------- //
  // if (option.items.length > 0) console.log('updateOptionProps', option)

  // When there's a fee, we want to show "Your Cost" with decimals | Connecticut + some Colorado clinics
  // This should not affect the above calculation - It's for display purposes only
  if (option.fee > 0) {
    option.finalTotalCost = accurateFinalTotalCost;
    option.costAfterSavings = accurateFinalTotalCost - option.fee;
  }

  return { ...option };
};

// -------------  Throwback logic ------------------ //
//   option.throwback = calculateSum(
//     option.items.map((item) => throwbacks[item.id] || 0)
//   );
//   option.totalSavings -= option.throwback;
// ------------------------------------------------------------------------- //

// import { hasTerm } from './lenderUtils.ts';
// --------------- For Non Standard Terms --------------- //
// Keep this logic here after the finalTotalCost is calculated
// When active lender does NOT have a term matching active.financePlan (24 or 36)
// then default to lender's first term -> Assuming there's only ONE non standard term left (60 months as for now)
//   if (!hasTerm(active.lender, active.financePlan)) {
//     option.financePlan = active.lender.terms[0].term;
//   }
